import React from 'react'
import { formatPrice } from '../utils/formatters'

export default function PackageCard({ package: pkg, onClick }) {
  return (
    <article
      className="bg-white rounded-xl overflow-hidden shadow-sm cursor-pointer hover:shadow-md transition-shadow"
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onClick()}
      aria-label={`${pkg.name}, from ${formatPrice(pkg.base_price_pence)} per person`}
    >
      {pkg.image_url && (
        <div className="h-40 overflow-hidden">
          <img
            src={pkg.image_url}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      )}

      <div className="p-4">
        <h3 className="text-lg font-bold text-gray-900">{pkg.name}</h3>
        {pkg.description && (
          <p className="text-sm text-gray-600 mt-1 line-clamp-2">{pkg.description}</p>
        )}
        <div className="flex items-center justify-between mt-3">
          <span className="text-sky-900 font-bold">
            From {formatPrice(pkg.base_price_pence)} pp
          </span>
          {pkg.min_guests && (
            <span className="text-xs text-gray-500">
              {pkg.min_guests}–{pkg.max_guests || '∞'} guests
            </span>
          )}
        </div>
      </div>
    </article>
  )
}
